module.exports = __webpack_public_path__ + "static/media/Motorola Moto 360 Women Silver + Blush Closed.0b0ff425.png";